import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { BehaviorSubject, Observable, of, timer } from 'rxjs';
import { concatMap, delay, map, startWith, switchMap, tap } from 'rxjs/operators';
import { NotificationModel } from '../../models/notification';
import { NOTIFICATION } from '../../tokens';

@Component({
    selector: 'app-notification-outlet',
    templateUrl: './notification-outlet.component.html',
    styleUrls: ['./notification-outlet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationOutletComponent {
    notification$: Observable<NotificationModel | null>;
    get notificationElm(): HTMLDivElement {
        return window['notification'];
    }

    constructor(
        private _detector: ChangeDetectorRef,
        @Inject(NOTIFICATION)
        _notification$: BehaviorSubject<NotificationModel>,
    ) {
        this.notification$ = _notification$.pipe(
            tap(curr => {
                var notificationKeyframes = new KeyframeEffect(
                    this.notificationElm,
                    [
                        { opacity: '0' },
                        { opacity: '1', offset: 0.1 },
                        { opacity: '1', offset: 0.9 },
                        { opacity: '0' },
                    ],
                    { duration: curr.duration||5500, fill: 'forwards' }
                );
                var notificationAnimation = new Animation(notificationKeyframes, document.timeline);
                notificationAnimation.play();
            })
        );
        // let _timer = null;

        // this.notification$ = new Observable((subscriber) => {
        //     _notification$.forEach((curr) => {
        //         console.log('Hello');
        //         subscriber.next(curr);
        //         queueMicrotask(() =>
        //             this._detector.detectChanges()
        //         )
        //         setTimeout(() => {
        //             console.log('Hello');
        //             subscriber.next(null);
        //             queueMicrotask(() =>
        //                 this._detector.detectChanges()
        //             )
        //         }, curr.duration || 55000);
        //     })
        // });


        // _notification$.pipe(
        //     tap(curr => {
        //         console.log('time', curr.duration, new Date().getTime())
        //     }),
        //     concatMap(curr => timer(curr.duration || 55000)
        //         .pipe(
        //             tap(() => {
        //                 console.log('time', curr.duration, new Date().getTime())
        //             }),
        //             map(_ => null),
        //             startWith(curr),
        //         )
        //     ),
        //     tap(() => {
        //         console.log('update')
        //         queueMicrotask(() =>
        //             this._detector.detectChanges()
        //         )
        //     }),
        // )
    }

}
